import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddRoomWizard.scss";
import autobind from "autobind-decorator";
import AddRoomIcon from "../assets/images/add-room-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createRoom, listRooms} from "../redux/actions/table/rooms";
import AddRoomForm from "../forms/add_room_wizard/AddRoomForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["rooms"],
}))
class AddRoomWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createRoom(this.props.match.params.stage, formData).then(({response}) => {
				listRooms(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('rooms', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('rooms', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-room.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-room.title.add-new-room')}</span>
						<span>{__('wizard.add-room.subtitle.add-new-room')}</span>
					</div>
					<div className={styles.right}>
						<AddRoomIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddRoomForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
							outdoor: '0'
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddRoomWizard;